import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import redirectData from '../data/shopify_redirect_map.json';

/**
 * Catches legacy Shopify URLs like /products/{handle} and 301-equivalent
 * redirects to the new /product/{slug}. The actual HTTP 301 status comes
 * from the production server's _redirects / .htaccess (so Googlebot sees
 * the correct status code). This component is the fallback for users who
 * land here from direct shares and for environments without server rewrites.
 *
 * Also emits a noindex header so this URL is never indexed independently
 * and Google attributes ranking to the new /product/{slug} canonical.
 */
const REDIRECTS = redirectData.redirects || {};
const UNMATCHED = redirectData.unmatched || {};

export default function ShopifyRedirect() {
  const { handle } = useParams();

  // Always emit noindex while this short-lived component is mounted.
  React.useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  const target = REDIRECTS[handle];
  if (target) {
    return <Navigate to={`/product/${target}`} replace />;
  }
  const fallbackName = UNMATCHED[handle];
  if (fallbackName) {
    return <Navigate to={`/search?q=${encodeURIComponent(fallbackName)}`} replace />;
  }
  // Nothing matched — go home but keep follow=true so any remaining link
  // juice flows somewhere useful.
  return <Navigate to="/" replace />;
}
